import React, { PureComponent } from 'react';
import { css, theme, TABBAR_HEIGHT } from 'constants';
import { View, ScrollView, Dimensions, I18nManager } from 'react-native';
import { Scene, Link, Text, isWeb, isAndroid } from './index';
import { isChrome, isFirefox, isSafari } from './platform';

const page_width = Dimensions.get('window').width;
const styles = css({
    page: {
        width: page_width,
        minWidth: page_width,
        flex: 1
    },
    tab_bar: {
        backgroundColor: theme.gray_color_lighten(0.01),
        flexDirection: 'row'
    },
    tab_bar_top: {
        borderBottomWidth: theme.hairline,
        borderBottomColor: theme.gray_color_lighten(0.2)
    },
    tab_bar_bottom: {
        borderTopWidth: theme.hairline,
        borderTopColor: theme.gray_color_lighten(0.2)
    }
});

export class TabNavigator extends PureComponent {
    state = { width: page_width };
    componentDidMount() {
        let { initialValue, animated } = this.props;
        const value = initialValue || 0;
        this._scrollToIndex(value, animated);
        isWeb && (this.tab_scroll.getScrollableNode().style['overflow-x'] = 'hidden');
    }
    componentDidUpdate(prevProps) {
        let { value, animated } = this.props;
        this._scrollToIndex(value, animated);
    }
    _XforRTL = x => {
        const xReverse = I18nManager.isRTL ? this.state.width * (this.props.children.length - 1) - x : x;
        const xMirror = I18nManager.isRTL ? x * -1 : x;
        if (isAndroid || isChrome) {
            return xReverse;
        } else if (isFirefox || isSafari) {
            return xMirror;
        } else {
            return x;
        }
    };

    _scrollToIndex = (val, animated) => {
        this.tab_scroll.scrollTo({ x: this._XforRTL(this.state.width * val), animated: animated || false });
    };
    _renderTabs = () => {
        const { tabs, value, tab_bar_style, tab_style, isTop } = this.props;
        return (
            <View style={[styles.tab_bar, isTop ? styles.tab_bar_top : styles.tab_bar_bottom, tab_bar_style]}>
                {tabs
                    ? tabs.map((Tab, index) => (
                          <Link
                              key={index}
                              onPress={() => this._onChange(index)}
                              content_style={[{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: TABBAR_HEIGHT }, tab_style]}
                              style={{ flex: 1 }}
                          >
                              {Tab.icon ? <Tab.icon size={26} selected={index === value} /> : null}
                              {Tab.text ? <Text style={{ marginTop: 5, color: index === value ? theme.primary_color : theme.gray_color }}>{Tab.text}</Text> : null}
                          </Link>
                      ))
                    : null}
            </View>
        );
    };
    _onChange = val => {
        const { onChange, value } = this.props;
        val !== value && onChange && Number.isInteger(val) && onChange(val);
    };
    _onSwipe = e => this._onChange(Math.round(this._XforRTL(e.nativeEvent.contentOffset.x) / this.state.width, 10));

    _onLayout = e => this.setState({ width: e.nativeEvent.layout.width });
    render() {
        const { children, isTop, page_style, swipeEnabled, ...props } = this.props;
        return (
            <Scene>
                {isTop ? this._renderTabs() : null}
                <ScrollView
                    onLayout={this._onLayout}
                    onMomentumScrollEnd={this._onSwipe}
                    keyboardShouldPersistTaps={'handled'}
                    horizontal={true}
                    pagingEnabled={true}
                    style={{ flex: 1 }}
                    showsHorizontalScrollIndicator={false}
                    scrollEnabled={isWeb ? true : !!swipeEnabled}
                    {...props}
                    ref={ref => (this.tab_scroll = ref)}
                >
                    {children
                        ? children.map((page, index) =>
                              page ? (
                                  <View key={index} style={[styles.page, this.state.width && { width: this.state.width, minWidth: this.state.width }, page_style]}>
                                      {page}
                                  </View>
                              ) : null
                          )
                        : null}
                </ScrollView>
                {!isTop ? this._renderTabs() : null}
            </Scene>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/tab_navigator.js